<template>
  <div id="app">
    <div class="fixed">
      <NavigationBar :title="title" />
      <CategorySwitch v-if="showBrand" :cur-category-id="categoryId" :categories="categoryList" @category-switch="_categorySwitch" />
    </div>
    <van-list v-model="loading" :finished="finished" :offset="offset" :immediate-check="false" :class="{'brandList':true,'app-pad':appStyle,'weixin-pad':weixinStyle,hasCategory:!isBrand}" @load="_toGet()">
      <ul class="brand-rank" :class="{isBrandStyle: isBrand}">
        <li v-for="(item, index) in list" :key="item.brandId" class="rank-item" @click="_tobrandIndex(item.brandId, index)">
          <div class="left">
            <img v-if="index == 0" src="../../images/1.png" class="rank-img">
            <img v-else-if="index == 1" src="../../images/2.png" class="rank-img">
            <img v-else-if="index == 2" src="../../images/3.png" class="rank-img">
            <span v-else class="text">{{ index + 1 }}</span>
            <div class="logo-box">
              <img :src="item.brandLogo" alt="" class="logo">
            </div>
            <div class="brank-info">
              <div class="brand-name single-line-ellipsis">{{ item.brandName }}</div>
              <div class="brand-num">门店数：{{ item.shopCount }}</div>
            </div>
          </div>
          <div class="right">
            <div class="heat-num">{{ item.heat }}</div>
            <div class="heat-text">齐家品牌热度</div>
          </div>
        </li>
      </ul>
    </van-list>
    <div v-if="show" class="list-more">
      <a class="more" @click="_toCheckMore()">
        更多品牌详情
        <i class="iconfont icon-arrow-right" />
      </a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { Toast, List } from 'vant';
import NavigationBar from '@/components/NavigationBar.vue';
import CategorySwitch from '@/components/CategorySwitch.vue';
import nativeBrandIndex from '../../filters/nativeBrandIndex';
import { isApp, isWeiXin } from '@/lib/compatibility';
import Util from '../../lib/util';

Vue.use(Toast).use(List);

export default {
  name: 'App',
  components: {
    NavigationBar,
    CategorySwitch,
  },

  data() {
    return {
      categoryId: 2,
      list: [],
      title: '',
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      show: false,
      offset: Util.px2docpx(100),
      categoryList: [],
      isBrand: false,
      showBrand: true,
    };
  },

  computed: {
    appStyle() {
      return isApp;
    },
    weixinStyle() {
      return isWeiXin;
    },
  },
  created() {
    this._initData();
  },

  methods: {
    _initData() {
      this.categoryList = globalData.categoryList;
      const params = Util.parseSearchParams(window.location.search);
      this.isBrand = params.isBrand === 'true';
      if (this.isBrand) {
        this.showBrand = false;
        this.show = false;
        this.title = `${globalData.categoryName}排行榜`;
      } else {
        this.title = '品牌榜单';
      }
      Object.assign(this.$data, globalData);
      if (sessionStorage.getItem('brandListCategoryId')) {
        this.categoryId = Number(sessionStorage.getItem('brandListCategoryId'));
        this._toGet(this.categoryId);
      } else {
        this.categoryId = globalData.categoryId;
        if (this.isBrand) {
          const bzBrand = globalData.bzBrands;
          this.list.push(...bzBrand);
          this.page = this.page + 1;
        } else {
          this._toGet();
        }
      }
    },

    _categorySwitch(category) {
      this.categoryId = category.categoryId;
      this.list = [];
      this.page = 0;
      this.finished = false;
      this._toGet();
    },

    _toGet() {
      this.show = false;
      this.loading = true;
      const page = ++this.page;
      axios.post(`${globalRootUrl}brandlist/rank`, {
        categoryId: this.categoryId,
        page,
        pageSize: this.pageSize,
      })
        .then((res) => {
          const { data } = res;
          if (!data || !data.bzBrands) throw new Error('获取榜单列表异常');
          if (page * this.pageSize >= data.totalCount) {
            this.finished = true;
          }
          this.loading = false;
          if (data.bzBrands.length === 0) {
            if (this.isBrand) {
              this.show = false;
            } else {
              this.show = true;
            }
            return;
          }
          this.list.push(...data.bzBrands);
          if (this.isBrand) {
            this.show = false;
          } else {
            this.show = true;
          }
        }).catch((err) => {
          console.warn(err);
          Toast.fail('获取榜单列表异常');
        });
    },

    _toCheckMore() {
      window.location.href = `${globalRootUrl}ppzq/`;
    },

    _tobrandIndex(brandId) {
      window.location.href = nativeBrandIndex(`${globalRootUrl}ppzq/brand-${brandId}/`);
    },
  },
};
</script>

<style lang="less">
@import "../../style/common.less";

.fixed {
  position: fixed;
  width: 100%;
  box-sizing: border-box;
  z-index: 9;
  background: #fff;
  max-width: 750px;
}

.list-more {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin: 0 0 60px;

  .more {
    border: 1PX solid #666;
    background-color: #fff;
    border-radius: 36px;
    padding: 0 60px 0 67px;
    line-height: 73px;
    box-sizing: border-box;
    display: inline-flex;
    text-decoration: none;
    color: #121529;
    font-size: 28px;

    .icon-arrow-right {
      font-weight: bold !important;
      margin-left: 10px;
      .font-title();
    }
  }
}

.brandList {
  padding-top: 119px;

  &.app-pad {
    padding-top: 9px;
  }

  &.weixin-pad {
    padding-top: 9px;
  }

  &.hasCategory {
    padding-top: 228px;

    &.app-pad {
      padding-top: 118px;
    }

    &.weixin-pad {
      padding-top: 108px;
    }
  }
}

#app {
  background: #fff;
}

.brand-rank {
  padding: 60px 28px 10px;

  &.isBrandStyle {
    padding: 30px 28px 40px;

    .rank-item:last-child {
      border-bottom: none;
    }
  }

  .rank-item {
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 40px;
    padding-bottom: 40px;
    border-bottom: 1px solid #ecebeb;

    .left {
      display: flex;
      align-items: center;

      .rank-img {
        width: 65px;
        height: 46px;
        object-fit: cover;
        margin-right: 30px;
      }

      .text {
        font-size: 50px;
        font-weight: 700;
        // font-style: italic;
        color: #848494;
        margin-right: 30px;
        width: 65px;
        text-align: center;
      }

      .logo-box {
        width: 100px;
        height: 100px;
        border-radius: 10px;
        border: 1PX solid #ecebeb;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 22px;

        .logo {
          width: 90px;
          height: auto;
        }
      }

      .brank-info {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        flex-flow: column wrap;

        .brand-name {
          font-size: 32px;
          font-weight: bold;
          color: #121529;
          width: 262px;
        }

        .brand-num {
          font-size: 24px;
          color: #ff8e00;
          line-height: 30px;
          margin: 22px 0 8px;
        }
      }
    }

    .right {
      margin-left: auto;
      display: flex;
      text-align: center;
      flex-flow: column;
      align-items: center;
      justify-content: flex-end;

      .heat-num {
        font-size: 36px;
        font-weight: bold;
        color: #121529;
      }

      .heat-text {
        line-height: 30px;
        font-size: 24px;
        color: #848494;
        margin: 23px 0 8px;
      }
    }
  }
}
</style>
